module.exports = __webpack_public_path__ + "static/garage_entrance_door_night-d673ba2b7719b95be3849feaf9eb3562.jpg";